import { render, staticRenderFns } from "./footerBot.vue?vue&type=template&id=50ef17d2&scoped=true"
import script from "./footerBot.vue?vue&type=script&lang=js"
export * from "./footerBot.vue?vue&type=script&lang=js"
import style0 from "./footerBot.vue?vue&type=style&index=0&id=50ef17d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef17d2",
  null
  
)

export default component.exports